import Service from './Service';
import TriagemApi from '../api/TriagemApi';
import { Triagem, TriagemCampo, TriagemGrupo } from '../modelo/Triagem';
import { Processo } from '../modelo';
import ProcessoApi from '../api/ProcessoApi';
import { Tema } from '@/modelo/Tema';


class TriagemService {

    async buscarTriagemGrupo(): Promise<TriagemGrupo[]> {
        return await TriagemApi.buscarTriagemGrupo();
    }

    async buscarTriagemCampos(): Promise<TriagemCampo[]> {
        return await TriagemApi.buscarTriagemCampos();
    }

    async buscarTemas(): Promise<any[]> {
        return await TriagemApi.buscarTemas();
    }

    /* Serviço que utiliza o codProcesso do GE */
    async buscarTemasDoProcesso(codProcesso: number): Promise<any> {
        return await TriagemApi.buscarTemasDoProcesso(codProcesso);
    }

    async adicionarTemaProcesso(codTema: number, codProcesso: number) {
        return await TriagemApi.adicionarTemaProcesso(codTema, codProcesso);
    }

    async removerTemaProcesso(codTema: number, codProcesso: number) {
        return await TriagemApi.removerTemaProcesso(codTema, codProcesso);
    }

    /* Serviço que utiliza o codProcesso do GE */
    async buscarTriagem(codProcesso: number): Promise<Triagem> {
        return await TriagemApi.buscarTriagem(codProcesso);
    }

    async salvarTriagem(triagem: Triagem): Promise<Triagem> {
        return await TriagemApi.salvarTriagem(triagem);
    }

    async salvarTriagemLivre(idsProcesso: number[], triagemLivre: string) {
        return await ProcessoApi.salvarTriagemLivre(idsProcesso, triagemLivre);
    }

    async buscarTriagemLivre(idsProcessos: number[]) {
        return await ProcessoApi.recuperarTriagemLivreDeProcessos(idsProcessos);
    }

    async buscarObices(): Promise<any[]> {
        return await TriagemApi.buscarObices();
    }

    async buscarObicesTemasProcesso(idsProcessos: number[]) {
        return await TriagemApi.buscarObicesTemasProcesso(idsProcessos);
    }

    async adicionarObiceTemaProcesso(codObice: number, codTema: number, codProcesso: number) {
        return await TriagemApi.adicionarObiceTemaProcesso(codTema, codProcesso, codObice);
    }

    async removerObiceTemaProcesso(codObice: number, codTema: number, codProcesso: number) {
        return await TriagemApi.removerObiceTemaProcesso(codTema, codProcesso, codObice);
    }

    async buscarTriagemDeTodosOsProcessos(idsProcesso: number[]): Promise<Map<number, Triagem>> {//Promise<Map<number, number[]>> {
        const ids = [];
        idsProcesso.forEach(id => ids[id] = id);
        return await TriagemApi.buscarTriagemTodosProcessos(Object.values(ids));
    }

    async buscarTemasDeTodosOsProcessos(idsProcesso: number[]): Promise<Map<number, Tema[]>> {//Promise<Map<number, number[]>> {
        const ids = [];
        idsProcesso.forEach(id => ids[id] = id);
        return await TriagemApi.buscarTemasTodosProcessos(Object.values(ids));
    }

}

export default new TriagemService();
